var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blockTime"},[_c('p',{staticClass:"day"},[_vm._v(_vm._s(_vm.day))]),_c('div',{staticClass:"year-month"},[_vm._v("\n    "+_vm._s(_vm.year)+"."+_vm._s(_vm.month)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }